<template lang="pug">
.entity-list
  .entity-list.pa-5()
    template
      template(v-for="(item, i) in instance")
        .quote
          v-row
            v-col.d-flex.align-center(cols="2")
              h2.primary--text {{$tc('Quote._name', 1)}} {{ i+1 }}
            v-col.d-flex.align-center(cols="3")
              h5.primaryHover--text {{$tc('QuoteItem._name', 2)}}: {{quoteItemsLength(item)}}
            v-col.d-flex.align-center(cols="3")
              h5.primaryHover--text {{$t('Quote.quoteTotal')}}: {{quoteTotal(item)}}
          v-row
            v-col.limit-column
              v-text-field(
                :value="item.externalId",
                :label="$t('Quote.externalId')",
                disabled,
              )
            v-col
              v-text-field(
                :value="item.customerReference",
                :label="$t('Quote.customerReference')",
                disabled,
                :error-messages="errors['quote.customerReference']",
                :error="!!errors['quote.customerReference']",
              )
            v-col.limit-column
              v-text-field(
                :value="item && item.status && item.status.name",
                :label="$t('Quote.status')",
                disabled,
              )
            v-col
              v-text-field(
                :value="item.rateCard",
                :label="$t('Quote.rateCard')",
                disabled,
              )
            v-col.limit-column
              app-datetime-picker(
                :value="item.createdAt",
                :label="$t('Quote.createdAt')",
                disabled,
              )
            v-col.limit-column
              v-text-field(
                :label="$t('Quote.user')",
                :value="(item.user || {}).fullName",
                disabled,
              )
          extra-field-groups(disabled, v-bind="{ entity, path }")
          v-row
            v-col.d-flex.align-center
              h2.primary--text {{$tc('QuoteItem._name', 2)}}
          g-data-table(
            :headers="quoteItemHeaders",
            :items="item.quoteItems || []",
          )
            template(v-slot:item="{ headers, item }")
              tr
                template(v-for="header in headers")
                  td(v-if="header.extra") {{ $getExtraFieldValueById(item, header) }}
                  td(v-else) {{ item[header.value] }}
</template>

<style lang="scss" scoped>
.quote {
  .limit-column {
    max-width: 155px;
  }
}
</style>

<script>
import EntityMixin from '@/mixins';
import EntitiesMixin from '@/mixins/entities.mixin';

export default {
  mixins: [EntityMixin,EntitiesMixin],
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    entity: null,
    path: null,
    parentInstance: {
      type: Object,
      default: () => { return {} }
    },
  },
  data: () => ({
    headers: [
      { text: "Service Item", value: "serviceItem" },
      { text: "Quantity", value: "quantity" },
      { text: "UoM", value: "handlingUnit" },
      { text: "Rate", value: "rate" },
      { text: "Subtotal", value: "subtotal" },
      { text: "Remarks", value: "remarks" },
    ],
    currencies: [],
  }),
  computed: {
    quoteItemsEntity() {
      return this.$findEntity('QuoteItem');
    },
    extraFieldGroups() {
      return _.get(this.quoteItemsEntity, 'fields', []).filter(f => f.extra);
    },
    getAllExtraFields() {
      return _.chain(this.extraFieldGroups)
        .reduce((acc, group) => {
          let groupFields = _.get(group, 'fields', []);
          groupFields = _.map(groupFields, x => ({ ...x, text: x.label || x.name, value: x.name }));
          return [...acc, ...groupFields];
        }, [])
        .value();
    },
    quoteItemHeaders() {
      return [...this.headers, ...this.getAllExtraFields];
    },
  },
  methods: {
    quoteTotal(item) {
      return `${this.currencySymbol(item)}${this.grandTotal(item)} ${item.currency || ""}`;
    },
    quoteItemsLength(item) {
      return item.quoteItems ? item.quoteItems.length : 0;
    },
    currencySymbol(item) {
      let selectedCurrency = this.currencies.find(c => c.code === item.currency);
      return selectedCurrency ? selectedCurrency.symbolNative : '';
    },
    grandTotal(item) {
      let grandT = 0;
      for (var i = 0; item.quoteItems && i < item.quoteItems.length; i++) {
        grandT = grandT + Number(item.quoteItems[i].subtotal);
      }
      return (Number(grandT).toFixed(2));
    },
  },
  async initializeCurrencies() {
    this.currencies = await this.loadCurrencies();
  },
  async created() {
    this.initializeCurrencies();
  },
}
</script>
